import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
	selector: '[appValidatePhone][formControlName],[appValidatePhone][formControl],[appValidatePhone][ngModel]',
	providers: [
		{
			provide: NG_VALIDATORS,
			useExisting: forwardRef(() => PhoneValidator),
			multi: true
		}
	]
})
export class PhoneValidator implements Validator {
	validate(c: AbstractControl) {
		if (c.value == null || c.value.length === 0) {
			return null;
		} else {
			const PHONE_REGEX = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}\s?[\s.x]?\d{0,5}$/i;

			return PHONE_REGEX.test(c.value) ? null : {
				invalidPhoneNumber: true
			};
		}
	}
}
